module.exports = __webpack_public_path__ + "static/media/Conways.31a86838.mp4";